import React from 'react';
import toast from 'react-hot-toast';
import { CreatePartnerFormProps } from './types';
import { Modal, SchemaForm } from '@v2/components';
import { useCreatePartner } from '@v2/hooks';
import { partnerSchema, partnerFields } from './schema';
import type { PartnerFormValues } from './schema';

const CreatePartnerForm: React.FC<CreatePartnerFormProps> = ({
  onCancel,
  onCompleted,
}) => {
  const { createPartner, loading, error: createError } = useCreatePartner();

  const handleSubmit = async (data: PartnerFormValues) => {
    const partnerId = await createPartner({ name: data.name.trim() });
    if (partnerId !== null) {
      toast.success('Partner created successfully');
      onCompleted?.();
    } else {
      toast.error('Failed to create partner');
    }
  };

  return (
    <Modal isOpen={true} onClose={onCancel} title="New Partner" size="md">
      <SchemaForm
        fields={partnerFields}
        schema={partnerSchema}
        onSubmit={handleSubmit}
        loading={loading}
        error={createError}
        submitLabel="Submit"
        onCancel={onCancel}
        cancelLabel="Cancel"
      />
    </Modal>
  );
};

export default CreatePartnerForm;
